import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import TrainingCreate from "./trainingCreate";
import TrainingEdit from "./trainingEdit";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getTrainingBlocks,
  getTrainingBlock,
  deleteTrainingBlock,
} from "../../../../../action/masters/trainingActionCreator";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import {
  ITrainingBlockIndex,
  ITrainingBlocks,
} from "../../../../../models/master/training";
import { setTrainigBlocks } from "../../../../../store/slices/master/trainingBlockSlice";
import ReactModal from "react-modal";
import LoaderSpinner from "../../../../../common-components/loader";
import { UserTypes } from "../../../../../models/dashboard/adminDashboard";

const TrainingIndex = (props: ITrainingBlockIndex) => {
  const {
    getTrainingBlocks,
    trainingBlocks,
    getTrainingBlock,
    trainingBlock,
    deleteTrainingBlock,
  } = props;
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);

  const dispatch = useDispatch();

  const editItem = async (id: number) => {
    setShowEdit(true);
    setIsEditLoading(true);
    try {
      await getTrainingBlock(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteTrainingBlock(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getAllTrainingBlocks();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllTrainingBlocks = async () => {
    setIsLoading(true);
    try {
      await getTrainingBlocks();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllTrainingBlocks();
    return () => {
      dispatch(setTrainigBlocks([]));
    };
  }, []);
  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Training</h2>
          <a
            href="javascript:void(0)"
            className="btn btn-primary"
            data-bs-toggle="modal"
            data-bs-target="#addnewbuttons"
            onClick={() => {
              setShowCreate(true);
            }}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>
        <ul className="d-flex grid-3 gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : trainingBlocks && trainingBlocks.length > 0 ? (
            trainingBlocks?.map((trainingBlock: ITrainingBlocks) => {
              return (
                <li
                  className="admin-card"
                  style={{
                    pointerEvents: !trainingBlock.isActive ? "none" : "auto",
                    opacity: !trainingBlock.isActive ? 0.5 : 1,
                  }}
                >
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(trainingBlock.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(trainingBlock.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <div className="btm training-card p-0">
                    <h2>{trainingBlock.name}</h2>
                    <h6>{trainingBlock.trainingCategory}</h6>
                    <p className="para-hide-1">{trainingBlock.description}</p>
                    <div className="btn-flex justify-content-start mt-2 border-top opacity-100 justify-content-start gap-2">
                      <button
                        type="button"
                        className={
                          trainingBlock.isMandatory
                            ? "btn-icon-border btn-tooltip tran-mandaroty active"
                            : "btn-icon-border btn-tooltip tran-mandaroty"
                        }
                        data-tooltip="Mandatory Training"
                        data-tooltip-pos="up"
                      >
                        <span>
                          <i className="fa-solid fa-star"></i>
                        </span>
                      </button>
                      <button
                        type="button"
                        className={
                          trainingBlock.isAttendInPerson
                            ? "btn-icon-border btn-tooltip tran-inperson active"
                            : "btn-icon-border btn-tooltip tran-inperson"
                        }
                        data-tooltip="In-Person Training"
                        data-tooltip-pos="up"
                      >
                        <span>
                          <i className="fa-solid fa-user"></i>
                        </span>
                      </button>
                      <button
                        type="button"
                        className={
                          trainingBlock.isOnline
                            ? "btn-icon-border btn-tooltip tran-online active"
                            : "btn-icon-border btn-tooltip tran-online"
                        }
                        data-tooltip="Online Training"
                        data-tooltip-pos="up"
                      >
                        <i className="fa-solid fa-desktop"></i>
                      </button>
                    </div>
                  </div>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <TrainingCreate
          setShowCreate={handleCreateClose}
          getAllTrainingBlocks={() => getAllTrainingBlocks()}
        />
      </ReactModal>
      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <TrainingEdit
            trainingBlock={trainingBlock}
            setShowEdit={handleEditClose}
            getAllTrainingBlocks={() => getAllTrainingBlocks()}
          />
        </ReactModal>
      )}
      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getTrainingBlocks: (
    pageBlockId?: number,
    noOfItems?: number,
    configUserType?: number
  ) => getTrainingBlocks(pageBlockId, noOfItems, configUserType),
  getTrainingBlock: (id: number) => getTrainingBlock(id),
  deleteTrainingBlock: (id: number, callBack: Function) =>
    deleteTrainingBlock(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    trainingBlocks: state.trainingBlock.trainingBlocks,
    trainingBlock: state.trainingBlock.trainingBlock,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TrainingIndex);
